import { useState } from 'react';

import { usePlayerInstance } from '@/scenarios/legacy-player/lib/contexts/instance';
import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

import { VideoTrack } from '../types/instance';

export const useCurrentVideoTrack = () => {
    const instance = usePlayerInstance();
    const [videoTrack, setVideoTrack] = useState<VideoTrack | undefined>(
        () => instance?.videoTrack
    );

    useInstanceEffect((instance) => instance.onCurrentVideoTrackChange(setVideoTrack));

    return videoTrack;
};
